import { Button } from "@/shared/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Trash2 } from "lucide-react";
import t from "@/lang/lang";
import { CommonDialogFooter } from "@/shared/components/dialog/dialog-common";
import { useEffect, useState } from "react";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { OutboxStatus } from "../types/outbox";
import {
  useBusinessCentralOutboxGesecInvoiceDeleteMutation,
  useBusinessCentralOutboxGesecInvoicesShowQuery,
} from "@/services/backend/business-central/api/outbox-gesec-invoice-api";

export function OutboxGesecInvoiceDeleteDialog({
  outboxId,
  onSuccess,
}: {
  outboxId: string;
  onSuccess?: () => void;
}) {
  const [open, setOpen] = useState(false);
  const { data } = useBusinessCentralOutboxGesecInvoicesShowQuery({ outboxId });
  const [del, { isLoading, error, isSuccess, reset }] =
    useBusinessCentralOutboxGesecInvoiceDeleteMutation();

  useEffect(() => {
    if (isSuccess) {
      reset();
      setOpen(false);
      onSuccess?.();
    }
  }, [isSuccess, onSuccess, reset, setOpen]);

  const doDelete = () => {
    if (!data || isLoading) return;
    del({ outboxId });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          disabled={!data || data.outboxStatus === OutboxStatus.Sent}
          size="sm"
        >
          <Trash2 />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Übermittlung löschen?")}</DialogTitle>
          <DialogDescription>
            {t("Möchten Sie die Übermittlung wirklich löschen?")}
          </DialogDescription>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter
          isLoading={isLoading}
          onClickAction={doDelete}
          destructive
        />
      </DialogContent>
    </Dialog>
  );
}
